import React from 'react'

const RichSnippet = ({type, data}) => {

    return <script type='application/ld+json' dangerouslySetInnerHTML={ { __html: JSON.stringify(data)} } />
}

export default RichSnippet